export const translations = {
  fr: {
    header: {
      home: "Accueil",
      privacy: "Confidentialité",
      terms: "Conditions",
      support: "Aide",
      blog: "Blog",
      download: "Télécharger",
      switchToEnglish: "English",
      switchToFrench: "Français",
    },
    hero: {
      title: "Reçus intelligents. Retours faciles.",
      subtitle: "Transformez vos reçus en informations {smarter}, {clearer}",
      smarter: "plus intelligentes",
      clearer: "plus claires",
      description:
        "Prêts quand vous en avez besoin. Retrouvez vos achats instantanément, montrez-les en magasin et ne manquez plus jamais une garantie.",
      cta: "En savoir plus",
      tagline:
        "Gratuit à télécharger. Fonctionne avec les principaux détaillants canadiens.",
      beforeStep: "1 · Photographiez",
      afterStep: "2 · ReFound l'enrichit",
      lovedBy: "Adoré par les utilisateurs d'un océan à l'autre",
      earlyReviews: "premiers avis 5 étoiles",
    },
    problem: {
      itemNamesUnclear: "Les noms d'articles sont peu clairs",
      itemNamesUnclearDesc: "Les reçus affichent des codes cryptiques comme « MERCH SKU 847291 » au lieu des vrais noms de produits.",
      findingReceiptsTakesTime: "Trouver les reçus prend du temps",
      findingReceiptsTakesTimeDesc: "Fouiller dans les tiroirs, les courriels et les applications pour trouver ce reçu dont vous avez besoin.",
      returnsFeelStressful: "Les retours sont stressants",
      returnsFeelStressfulDesc: "Se présenter au comptoir des retours en espérant avoir le bon reçu et qu'il ne soit pas trop tard.",
      receiptsShouldNotBeHard: "Les reçus ne devraient pas être {hardToUse}",
      hardToUse: "difficiles à utiliser",
      weveAllBeenThere: "On est tous passés par là.",
      refoundFixesThat: "ReFound règle ça.",
    },
    features: {
      smarterReceipts: "Reçus intelligents",
      smarterReceiptsDesc: "Noms de produits clairs, images, informations de garantie du fabricant et liens vers les pages produits lorsque disponibles.",
      noMoreCrypticCodes: "Fini les codes cryptiques",
      moreThanProof: "Plus qu'une preuve d'achat",
      moreThanProofDesc: "Suivez les politiques de retour des magasins et les informations de garantie du fabricant pour les articles pris en charge.",
      knowYourCoverage: "Connaissez votre couverture",
      readyToShow: "Prêt à montrer en magasin",
      readyToShowDesc: "Vue prête pour le retour avec articles surlignés, code-barres scannable, détails de paiement et photo du reçu original.",
      everythingMerchantsNeed: "Tout ce dont les marchands ont besoin",
      warrantyAlerts: "Alertes de garantie",
      warrantyAlertsDesc: "Soyez notifié lorsque les garanties magasin ou fabricant sont sur le point d'expirer pour les produits éligibles.",
      neverMissDeadline: "Ne manquez jamais une échéance",
      refoundMakesReceiptsUseful: "ReFound rend les reçus {usefulAgain}",
      usefulAgain: "utiles à nouveau",
      featuresSubtitle: "Plus intelligents, plus clairs et plus faciles à utiliser — pour retrouver rapidement vos achats et les montrer instantanément quand ça compte.",
    },
    howItWorks: {
      howItWorksTitle: "Comment ça marche",
      howItWorksSubtitle: "Trois étapes simples vers des reçus plus intelligents.",
      snapYourReceipt: "Photographiez votre reçu",
      snapYourReceiptDesc: "Prenez une photo de n'importe quel reçu de n'importe quel marchand.",
      refoundEnrichesIt: "ReFound l'enrichit",
      refoundEnrichesItDesc: "Nous ajoutons automatiquement les noms de produits, images, informations de garantie et politiques de retour.",
      useItWhenNeeded: "Utilisez-le au besoin",
      useItWhenNeededDesc: "Affichez la vue prête pour le retour avec code-barres scannable dans n'importe quel magasin.",
    },
    retailers: {
      retailersTitle: "Fonctionne avec les détaillants canadiens populaires",
      retailersDesc: "Importez des reçus de n'importe quel magasin. Les images de produits, noms, URLs et informations de garantie du fabricant fonctionnent mieux avec les grands détaillants canadiens — et nous en ajoutons constamment.",
      retailersDisclaimer: "La disponibilité peut varier selon le magasin et le produit.",
    },
    testimonials: {
      whyUsersLove: "Pourquoi les utilisateurs {love} ReFound",
      love: "adorent",
      smarterClearerReceipts: "Des reçus plus intelligents et plus clairs",
      easierReturns: "Des retours en magasin plus faciles",
      warrantyReminders: "Des rappels de garantie avant qu'il ne soit trop tard",
      lessStressMoreConfidence: "Moins de stress, plus de confiance",
      testimonial1: "Enfin, je peux vraiment lire ce que j'ai acheté. Fini de deviner ce que « MERCH 847291 » veut dire!",
      testimonial2: "Les rappels de garantie m'ont fait économiser des centaines de dollars. J'avais presque oublié que ma perceuse était encore couverte.",
      testimonial3: "Les retours me stressaient énormément. Maintenant, je montre juste mon téléphone et c'est réglé en quelques secondes.",
    },
    download: {
      readyToMakeReceipts: "Prêt à rendre les reçus {usefulAgain}",
      downloadReFoundToday: "Téléchargez ReFound aujourd'hui et prenez le contrôle de vos reçus.",
      freeToDownload: "Gratuit à télécharger. Disponible sur iPhone (App Store) et Android (Google Play).",
    },
    footer: {
      stayInLoop: "Restez informé",
      followAlong:
        "Suivez-nous dans notre mission de simplifier les retours.",
      getInTouch: "Nous contacter",
      product: "Produit",
      features: "Fonctionnalités",
      howItWorks: "Comment ça marche",
      supportedRetailers: "Détaillants partenaires",
      legal: "Légal",
      privacyPolicy: "Politique de confidentialité",
      termsOfService: "Conditions d'utilisation",
      contactUs: "Contactez-nous",
      allRightsReserved: "Tous droits réservés.",
      madeInCanada: "Fait avec soin au Canada",
    },
    privacy: {
      title: "Politique de Confidentialité",
      lastUpdated: "Dernière mise à jour : 12 octobre 2026",
      intro: {
        title: "1. Introduction",
        content: "Bienvenue sur ReFound (l'« Application »). La présente Politique de confidentialité explique comment nous recueillons, utilisons, divulguons, conservons et protégeons vos renseignements personnels lorsque vous utilisez notre application mobile et nos services associés.",
        consent: "En utilisant ReFound, vous acceptez les pratiques décrites dans la présente politique. Si vous n'êtes pas d'accord avec cette politique, veuillez ne pas utiliser notre Application."
      },
      infoWeCollect: {
        title: "2. Informations que nous collectons",
        intro: "Pour vous fournir nos services, nous limitons la collecte de données à ce qui est strictement nécessaire.",
        directInfo: {
          title: "A. Informations que vous nous fournissez directement :",
          items: [
            "Informations de compte : Si vous créez un compte (via Apple, Google ou par courriel), nous collectons votre adresse courriel et votre nom d'utilisateur associé pour authentifier votre accès.",
            "Données de reçus (sauvegarde cloud optionnelle) : Si vous activez la sauvegarde cloud, nous collectons et hébergeons de manière chiffrée les photographies de vos reçus, ainsi que les données textuelles associées (nom du magasin, date, prix, garanties), pour permettre leur synchronisation sur vos appareils.",
            "Données de référence de paiement : Si vous choisissez volontairement de les ajouter pour organiser vos retours, nous stockons le nom personnalisé de la carte et uniquement les quatre (4) derniers chiffres de votre moyen de paiement. Nous ne collectons, ne traitons et ne stockons jamais vos numéros de carte de crédit complets, dates d'expiration ou codes de sécurité (CVV)."
          ]
        },
        autoInfo: {
          title: "B. Informations collectées automatiquement :",
          content: "Données d'appareil et d'utilisation : Nous pouvons recueillir des informations non nominatives sur votre appareil (modèle, version du système d'exploitation) et sur la façon dont vous interagissez avec l'Application (fonctionnalités utilisées, rapports de plantage) afin d'améliorer la stabilité et les performances de notre service."
        }
      },
      usageData: {
        title: "3. Données d’utilisation",
        content: "Pour améliorer l’application, ReFound enregistre certaines actions dans l’app (par exemple : étape de l’accueil atteinte, reçu numérisé, abonnement consulté). Lorsque vous êtes connecté, ces données sont associées à l’identifiant technique de votre compte, jamais à votre adresse courriel ni à votre nom. Elles ne sont pas partagées avec des tiers et ne servent pas à la publicité. Elles sont conservées 90 jours, puis seulement sous forme de totaux quotidiens."
      },
      howWeUse: {
        title: "4. Comment nous utilisons vos informations",
        intro: "Nous utilisons vos données exclusivement pour opérer et améliorer l'Application :",
        items: [
          "Créer et gérer votre compte.",
          "Fournir la sauvegarde cloud et la récupération de vos données lorsque vous activez cette option.",
          "Vous envoyer des notifications locales ou push concernant l'expiration de vos garanties ou les délais de retour (selon vos préférences).",
          "Répondre à vos demandes d'assistance technique.",
          "Analyser les performances de l'Application pour corriger les bugs."
        ],
        noSell: "Nous ne vendons, ne louons et ne commercialisons en aucun cas vos données personnelles à des tiers."
      },
      howWeStore: {
        title: "5. Où et comment nous stockons vos données",
        intro: "Le lieu de stockage dépend de votre utilisation de l'Application :",
        items: [
          "Stockage local (par défaut) : Si vous n'activez pas la sauvegarde cloud, toutes les données (y compris les photos de reçus) sont conservées sur votre appareil mobile ou dans votre propre compte iCloud personnel. Nous n'y avons aucun accès.",
          "Stockage cloud (si vous l'activez) : Vos données sont chiffrées en transit et au repos, et hébergées chez notre fournisseur d'infrastructure cloud, Supabase. La base de données principale de ReFound est hébergée au Canada. Les images de reçus sauvegardées sont conservées dans un stockage privé et ne sont pas publiquement accessibles."
        ]
      },
      thirdParty: {
        title: "6. Partage avec des tiers (Fournisseurs de services)",
        intro: "Nous pouvons partager vos informations uniquement avec des fournisseurs de services de confiance qui nous aident à opérer l'Application, sous stricte obligation de confidentialité :",
        items: [
          "Services d'hébergement et de base de données (Supabase) : Pour héberger les données chiffrées des utilisateurs qui ont activé la sauvegarde cloud.",
          "Services de lecture de reçus (OpenAI, Google Gemini, Anthropic) : Lorsque vous numérisez un reçu, nous transmettons uniquement l'image du reçu à ces services pour en extraire le marchand, les articles, les prix et les dates. Aucune autre donnée personnelle ne leur est transmise.",
          "Services d'authentification : Pour gérer les connexions sécurisées (Apple, Google).",
          "Exigences légales : Nous pouvons divulguer vos informations si la loi l'exige, en réponse à une ordonnance d'un tribunal, ou pour protéger nos droits, notre propriété ou notre sécurité."
        ]
      },
      dataSecurity: {
        title: "7. Sécurité de vos données",
        content: "Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles conformes aux standards de l'industrie pour protéger vos données contre l'accès non autorisé, la perte ou l'altération. L'accès aux données sauvegardées est restreint au compte qui les a créées, et les images de reçus sont conservées dans un stockage privé.",
        disclaimer: "Cependant, aucune méthode de transmission sur Internet ou de stockage électronique n'est sécurisée à 100 %. Par conséquent, bien que nous nous efforcions de protéger vos renseignements personnels, nous ne pouvons garantir leur sécurité absolue et déclinons toute responsabilité en cas de violation de données échappant à notre contrôle raisonnable."
      },
      dataRetention: {
        title: "8. Conservation et Suppression de vos données",
        intro: "Vous gardez le contrôle total sur vos données.",
        items: [
          "Conservation : Nous conservons les données que vous avez sauvegardées dans le cloud tant que votre compte est actif.",
          "Suppression : Vous pouvez supprimer définitivement l'intégralité de vos données hébergées sur nos serveurs à tout moment en utilisant l'option « Supprimer mon compte » située dans les paramètres de l'Application. Cette action est irréversible et effacera toutes vos photos et données de notre Cloud."
        ]
      },
      yourRights: {
        title: "9. Vos droits (Accès et Contrôle)",
        intro: "Selon votre juridiction (incluant la Loi 25 au Québec et la LPRPDE au Canada), vous disposez du droit de :",
        items: [
          "Accéder aux données personnelles que nous détenons à votre sujet.",
          "Demander la rectification de données inexactes.",
          "Retirer votre consentement à tout moment (en désactivant la sauvegarde cloud ou en supprimant votre compte)."
        ]
      },
      childrenPrivacy: {
        title: "10. Confidentialité des enfants",
        content: "Notre Application n'est pas destinée aux personnes de moins de 13 ans. Nous ne collectons pas sciemment de données auprès d'enfants de moins de 13 ans. Si nous découvrons qu'un enfant nous a fourni des informations personnelles, nous les supprimerons immédiatement de nos serveurs."
      },
      policyChanges: {
        title: "11. Modifications de cette politique",
        content: "Nous nous réservons le droit de modifier cette Politique de confidentialité à tout moment. Toute modification sera publiée sur cette page avec une date de « Dernière mise à jour » révisée. En continuant d'utiliser l'Application après ces modifications, vous acceptez la nouvelle politique."
      },
      contactUs: {
        title: "12. Nous contacter",
        content: "Pour toute question, préoccupation ou demande concernant vos données personnelles et cette politique, ou pour exercer vos droits, veuillez contacter notre responsable de la protection des données à :",
        email: "info@refoundapp.ca"
      }
    },
    terms: {
      title: "Conditions d'utilisation",
      lastUpdated: "Dernière mise à jour : janvier 2024",
      sections: [
        {
          title: "1. Acceptation des conditions",
          content: "En téléchargeant, installant ou utilisant l'application mobile ReFound (« Application »), vous acceptez d'être lié par les présentes Conditions d'utilisation (« Conditions »). Si vous n'acceptez pas ces Conditions, veuillez ne pas utiliser l'Application."
        },
        {
          title: "2. Description du service",
          content: "ReFound est une application de gestion de reçus qui permet aux utilisateurs de photographier, stocker et organiser leurs reçus. L'Application enrichit les reçus avec des informations sur les produits, effectue le suivi des garanties et des délais de retour, et fournit des vues de reçus prêtes à être présentées en magasin."
        },
        {
          title: "3. Responsabilités de l'utilisateur",
          content: "Vous vous engagez à :",
          items: [
            "Utiliser l'Application uniquement à des fins licites",
            "Fournir des informations exactes lors de la création de votre compte",
            "Maintenir la confidentialité de vos identifiants de connexion",
            "Ne pas tenter de procéder à l'ingénierie inverse ou de modifier l'Application",
            "Ne pas utiliser l'Application pour stocker des reçus frauduleux ou falsifiés"
          ]
        },
        {
          title: "4. Propriété intellectuelle",
          content: "L'Application et son contenu original, ses fonctionnalités et ses caractéristiques sont la propriété de ReFound et sont protégés par les lois internationales sur le droit d'auteur, les marques de commerce et autres lois sur la propriété intellectuelle. Vos données de reçus demeurent votre propriété."
        },
        {
          title: "5. Avis de non-garantie",
          content: "L'Application est fournie « telle quelle », sans garantie d'aucune sorte. Nous ne garantissons pas :",
          items: [
            "L'exactitude des informations enrichies sur les produits",
            "L'exactitude des informations relatives aux garanties ou aux délais de retour",
            "Que les commerçants accepteront les vues numériques des reçus",
            "Le fonctionnement ininterrompu ou sans erreur de l'Application"
          ],
          additionalContent: "Les informations relatives aux garanties et aux politiques de retour sont fournies à titre indicatif uniquement. Veuillez toujours vérifier auprès du détaillant pour connaître les politiques officielles."
        },
        {
          title: "6. Limitation de responsabilité",
          content: "Dans toute la mesure permise par la loi, ReFound ne saurait être tenue responsable de tout dommage indirect, accessoire, spécial, consécutif ou punitif, y compris la perte de profits, de données ou d'autres pertes immatérielles, résultant de votre utilisation de l'Application."
        },
        {
          title: "7. Services tiers",
          content: "L'Application peut contenir des liens vers des sites Web ou des services tiers. Nous ne sommes pas responsables du contenu, des politiques de confidentialité ou des pratiques de tout site ou service tiers."
        },
        {
          title: "8. Résiliation",
          content: "Nous pouvons résilier ou suspendre votre accès à l'Application immédiatement, sans préavis, pour quelque raison que ce soit, y compris en cas de violation des présentes Conditions. En cas de résiliation, votre droit d'utiliser l'Application prendra fin immédiatement."
        },
        {
          title: "9. Modifications des conditions",
          content: "Nous nous réservons le droit de modifier les présentes Conditions à tout moment. Nous vous informerons de tout changement important par l'intermédiaire de l'Application ou par courriel. Votre utilisation continue de l'Application après les modifications constitue une acceptation des nouvelles Conditions."
        },
        {
          title: "10. Loi applicable",
          content: "Les présentes Conditions sont régies et interprétées conformément aux lois du Canada, sans égard aux dispositions relatives aux conflits de lois."
        },
        {
          title: "11. Nous contacter",
          content: "Si vous avez des questions concernant les présentes Conditions, veuillez nous contacter à l'adresse",
          email: "info@refoundapp.ca"
        }
      ]
    },
    support: {
      title: "Comment pouvons-nous vous aider?",
      subtitle: "Nous sommes là pour vous aider à tirer le meilleur parti de ReFound.",
      emailSupport: {
        title: "Assistance par courriel",
        description: "Vous avez une question ou besoin d'aide? Envoyez-nous un courriel et nous vous répondrons dans les 24 heures.",
        email: "info@refoundapp.ca"
      },
      feedback: {
        title: "Commentaires",
        description: "Vous avez des idées de nouvelles fonctionnalités ou d'améliorations? Nous aimerions vous entendre.",
        buttonText: "Envoyer un commentaire"
      },
      faq: {
        title: "Questions fréquemment posées",
        questions: [
          {
            question: "Quels détaillants sont pris en charge?",
            answer: "Tous! Vous pouvez scanner n'importe quel reçu de n'importe quel magasin et l'utiliser pour un retour, avec le code-barres quand le reçu en a un. Pour une liste de détaillants populaires comme Canadian Tire, RONA, Home Depot, Walmart, IKEA, Costco, Best Buy, Sports Experts, Décathlon, BMR, Canac, Dollarama et Tigre Géant, les articles sont en plus enrichis avec le vrai nom du produit, une photo, un lien et parfois la garantie lorsque disponible. Nous ajoutons constamment de nouveaux détaillants."
          },
          {
            question: "Mes données de reçus sont-elles sécurisées?",
            answer: "Oui. Vos reçus restent privés et protégés. ReFound ne stocke jamais vos numéros complets de cartes de paiement, et nous ne vendons jamais vos informations personnelles."
          },
          {
            question: "Où sont stockées mes données?",
            answer: "Vos reçus sont conservés sur votre appareil, avec la possibilité d'activer la sauvegarde cloud pour les retrouver en cas de besoin. Les images sauvegardées dans le cloud sont conservées dans un stockage privé et ne sont pas publiquement accessibles. La base de données principale de ReFound est hébergée au Canada."
          },
          {
            question: "Comment fonctionne la numérisation des reçus?",
            answer: "Lorsque vous numérisez un reçu, nous utilisons des services d'IA (OpenAI, Google Gemini, Anthropic) pour extraire des informations telles que le nom du marchand, les articles, les prix et les dates. Nous partageons uniquement l'image du reçu avec ces services pour le traitement - aucune autre donnée personnelle."
          },
          {
            question: "Puis-je exporter ou supprimer mes données?",
            answer: "Oui. Vous pouvez consulter et exporter toutes vos données dans l'application. Vous pouvez supprimer des reçus individuels ou votre compte entier à tout moment. Lorsque vous supprimez des données, elles sont définitivement supprimées de nos serveurs."
          },
          {
            question: "Qu'en est-il des rappels de garantie?",
            answer: "ReFound suit les dates d'expiration des garanties et les délais de retour pour vos achats. Vous pouvez activer les notifications pour recevoir des rappels avant l'expiration des garanties. Cette fonctionnalité peut être activée ou désactivée dans vos paramètres."
          }
        ]
      },
      legalDocs: {
        title: "Documents légaux",
        privacyLink: "Politique de confidentialité",
        termsLink: "Conditions d'utilisation"
      }
    },
    demo: {
      title: "Plus besoin de chercher le reçu",
      subtitle: "Montrez simplement l'objet et ReFound trouve son reçu.",
      videoLabel: "Démonstration vidéo de ReFound : scanner un article pour retrouver son reçu",
      videoFallback: "Votre navigateur ne peut pas lire cette vidéo.",
      download4k: "Télécharger la vidéo en 4K",
      downloadCta: "Essayez ReFound gratuitement",
      freeNote: "Gratuit sur iPhone et Android.",
    },
  },
  en: {
    header: {
      home: "Home",
      privacy: "Privacy",
      terms: "Terms",
      support: "Support",
      blog: "Blog",
      download: "Download App",
      switchToEnglish: "English",
      switchToFrench: "Français",
    },
    hero: {
      title: "Smarter Receipts. Easy Returns.",
      subtitle: "Turn receipts into {smarter}, {clearer} insights",
      smarter: "smarter",
      clearer: "clearer",
      description:
        "Ready when you need them. Find what you bought instantly, show it in store, and never miss a warranty again.",
      cta: "Learn More",
      tagline: "Free to download. Works with major Canadian retailers.",
      beforeStep: "1 · Snap a photo",
      afterStep: "2 · ReFound enriches it",
      lovedBy: "Loved by users coast to coast",
      earlyReviews: "early 5-star reviews",
    },
    problem: {
      itemNamesUnclear: "Item names are unclear",
      itemNamesUnclearDesc: "Receipts show cryptic codes like \"MERCH SKU 847291\" instead of actual product names.",
      findingReceiptsTakesTime: "Finding receipts takes time",
      findingReceiptsTakesTimeDesc: "Digging through drawers, emails, and apps to find that one receipt when you need it.",
      returnsFeelStressful: "Returns feel stressful",
      returnsFeelStressfulDesc: "Standing at the returns counter hoping you have the right receipt and it's not too late.",
      receiptsShouldNotBeHard: "Receipts should not be {hard to use}",
      hardToUse: "hard to use",
      weveAllBeenThere: "We've all been there.",
      refoundFixesThat: "ReFound fixes that.",
    },
    features: {
      smarterReceipts: "Smarter Receipts",
      smarterReceiptsDesc: "Clear product names, images, manufacturer warranty info, and links to product pages when available.",
      noMoreCrypticCodes: "No more cryptic codes",
      moreThanProof: "More Than Proof of Purchase",
      moreThanProofDesc: "Track store return policies and manufacturer warranty information for supported items.",
      knowYourCoverage: "Know your coverage",
      readyToShow: "Ready to Show in Store",
      readyToShowDesc: "Return-ready view with highlighted items, scannable barcode, payment details, and original receipt photo.",
      everythingMerchantsNeed: "Everything merchants need",
      warrantyAlerts: "Warranty Alerts",
      warrantyAlertsDesc: "Get notified when store or manufacturer warranties are about to expire for eligible products.",
      neverMissDeadline: "Never miss a deadline",
      refoundMakesReceiptsUseful: "ReFound makes receipts {useful again}",
      usefulAgain: "useful again",
      featuresSubtitle: "Smarter, clearer, and easier to use — so you can quickly find what you bought and show it instantly when it matters.",
    },
    howItWorks: {
      howItWorksTitle: "How It Works",
      howItWorksSubtitle: "Three simple steps to smarter receipts.",
      snapYourReceipt: "Snap Your Receipt",
      snapYourReceiptDesc: "Take a photo of any receipt from any merchant.",
      refoundEnrichesIt: "ReFound Enriches It",
      refoundEnrichesItDesc: "We add product names, images, warranty info, and return policies automatically.",
      useItWhenNeeded: "Use It When Needed",
      useItWhenNeededDesc: "Pull up the return-ready view with scannable barcode at any store.",
    },
    retailers: {
      retailersTitle: "Works with Popular Canadian Retailers",
      retailersDesc: "Import receipts from any store. Product images, names, URLs, and manufacturer warranty info work best with major Canadian retailers — and we're adding more all the time.",
      retailersDisclaimer: "Availability may vary by store and product.",
    },
    testimonials: {
      whyUsersLove: "Why Users {love} ReFound",
      love: "Love",
      smarterClearerReceipts: "Smarter, clearer receipts",
      easierReturns: "Easier in-store returns",
      warrantyReminders: "Warranty reminders before it's too late",
      lessStressMoreConfidence: "Less stress, more confidence",
      testimonial1: "Finally, I can actually read what I bought. No more guessing what 'MERCH 847291' means!",
      testimonial2: "The warranty reminders saved me hundreds of dollars. I almost forgot my drill was still covered.",
      testimonial3: "Returns used to stress me out. Now I just show my phone and it's done in seconds.",
    },
    download: {
      readyToMakeReceipts: "Ready to Make Receipts {Useful Again}",
      downloadReFoundToday: "Download ReFound today and take control of your receipts.",
      freeToDownload: "Free to download. Available on iPhone (App Store) and Android (Google Play).",
    },
    footer: {
      stayInLoop: "Stay in the loop",
      followAlong: "Follow along as we make returns effortless.",
      getInTouch: "Get in touch",
      product: "Product",
      features: "Features",
      howItWorks: "How It Works",
      supportedRetailers: "Supported Retailers",
      legal: "Legal",
      privacyPolicy: "Privacy Policy",
      termsOfService: "Terms of Service",
      contactUs: "Contact Us",
      allRightsReserved: "All rights reserved.",
      madeInCanada: "Made with care in Canada",
    },
    privacy: {
      title: "Privacy Policy",
      lastUpdated: "Last Updated: October 12, 2026",
      intro: {
        title: "1. Introduction",
        content: "Welcome to ReFound (the \"App\"). This Privacy Policy explains how we collect, use, disclose, retain, and protect your personal information when you use our mobile application and related services.",
        consent: "By using ReFound, you agree to the practices described in this policy. If you do not agree with this policy, please do not use our App."
      },
      infoWeCollect: {
        title: "2. Information We Collect",
        intro: "To provide our services, we limit data collection to what is strictly necessary.",
        directInfo: {
          title: "A. Information you provide directly to us:",
          items: [
            "Account Information: If you create an account (via Apple, Google, or email), we collect your email address and associated username to authenticate your access.",
            "Receipt Data (optional cloud backup): If you turn on cloud backup, we securely collect and host encrypted photographs of your receipts, along with associated text data (store name, date, price, warranties), to allow synchronization across your devices.",
            "Payment Reference Data: If you voluntarily choose to add it to organize your returns, we store the custom nickname of the card and only the last four (4) digits of your payment method. We never collect, process, or store your full credit card numbers, expiration dates, or security codes (CVV/CVC)."
          ]
        },
        autoInfo: {
          title: "B. Information collected automatically:",
          content: "Device and Usage Data: We may collect non-personally identifiable information about your device (model, operating system version) and how you interact with the App (features used, crash reports) to improve the stability and performance of our service."
        }
      },
      usageData: {
        title: "3. Usage data",
        content: "To improve the app, ReFound records certain in-app actions (for example: onboarding step reached, receipt scanned, subscription screen viewed). When you are signed in, this data is associated with your account’s technical identifier, never with your email address or your name. It is not shared with third parties and is not used for advertising. It is kept for 90 days, then only as daily totals."
      },
      howWeUse: {
        title: "4. How We Use Your Information",
        intro: "We use your data exclusively to operate and improve the App:",
        items: [
          "To create and manage your account.",
          "To provide cloud backup and data recovery when you turn that option on.",
          "To send you local or push notifications regarding warranty expirations or return deadlines (based on your preferences).",
          "To respond to your technical support requests.",
          "To analyze App performance and fix bugs."
        ],
        noSell: "We never sell, rent, or trade your personal data to third parties under any circumstances."
      },
      howWeStore: {
        title: "5. Where and How We Store Your Data",
        intro: "Where your data is stored depends on how you use the App:",
        items: [
          "Local storage (default): If you do not turn on cloud backup, all data (including receipt photos) is kept on your mobile device or within your own personal iCloud account. We have no access to it.",
          "Cloud storage (if you turn it on): Your data is encrypted in transit and at rest, and hosted with our cloud infrastructure provider, Supabase. ReFound's main database is hosted in Canada. Backed-up receipt images are kept in private storage and are not publicly accessible."
        ]
      },
      thirdParty: {
        title: "6. Sharing with Third Parties (Service Providers)",
        intro: "We may share your information only with trusted service providers who help us operate the App, under strict confidentiality obligations:",
        items: [
          "Hosting and database services (Supabase): To host encrypted data for users who have turned on cloud backup.",
          "Receipt reading services (OpenAI, Google Gemini, Anthropic): When you scan a receipt, we send only the receipt image to these services to extract the merchant, items, prices and dates. No other personal data is shared with them.",
          "Authentication Services: To manage secure logins (Apple, Google).",
          "Legal Requirements: We may disclose your information if required by law, in response to a court order, or to protect our rights, property, or safety."
        ]
      },
      dataSecurity: {
        title: "7. Data Security",
        content: "We implement industry-standard technical and organizational security measures to protect your data against unauthorized access, loss, or alteration. Access to backed-up data is restricted to the account that created it, and receipt images are kept in private storage.",
        disclaimer: "However, no method of transmission over the Internet or electronic storage is 100% secure. Therefore, while we strive to protect your personal information, we cannot guarantee its absolute security and assume no liability for data breaches beyond our reasonable control."
      },
      dataRetention: {
        title: "8. Data Retention and Deletion",
        intro: "You retain full control over your data.",
        items: [
          "Retention: We keep the data you have backed up to the cloud as long as your account is active.",
          "Deletion: You can permanently delete all your data hosted on our servers at any time by using the \"Delete Account\" option located in the App's settings. This action is irreversible and will erase all your photos and data from our Cloud."
        ]
      },
      yourRights: {
        title: "9. Your Rights (Access and Control)",
        intro: "Depending on your jurisdiction (including PIPEDA in Canada and Law 25 in Quebec), you have the right to:",
        items: [
          "Access the personal data we hold about you.",
          "Request the correction of inaccurate data.",
          "Withdraw your consent at any time (by turning off cloud backup or deleting your account)."
        ]
      },
      childrenPrivacy: {
        title: "10. Children's Privacy",
        content: "Our App is not intended for individuals under the age of 13. We do not knowingly collect data from children under 13. If we discover that a child has provided us with personal information, we will immediately delete it from our servers."
      },
      policyChanges: {
        title: "11. Changes to This Policy",
        content: "We reserve the right to modify this Privacy Policy at any time. Any changes will be posted on this page with a revised \"Last Updated\" date. By continuing to use the App after these changes, you accept the new policy."
      },
      contactUs: {
        title: "12. Contact Us",
        content: "For any questions, concerns, or requests regarding your personal data and this policy, or to exercise your rights, please contact our Data Protection Officer at:",
        email: "info@refoundapp.ca"
      }
    },
    terms: {
      title: "Terms of Service",
      lastUpdated: "Last updated: January 2024",
      sections: [
        {
          title: "1. Acceptance of Terms",
          content: "By downloading, installing, or using the ReFound mobile application (\"Application\"), you agree to be bound by these Terms of Service (\"Terms\"). If you do not agree to these Terms, please do not use the Application."
        },
        {
          title: "2. Service Description",
          content: "ReFound is a receipt management application that allows users to photograph, store, and organize their receipts. The Application enriches receipts with product information, tracks warranties and return deadlines, and provides receipt views ready to be presented in-store."
        },
        {
          title: "3. User Responsibilities",
          content: "You agree to:",
          items: [
            "Use the Application only for lawful purposes",
            "Provide accurate information when creating your account",
            "Maintain the confidentiality of your login credentials",
            "Not attempt to reverse engineer or modify the Application",
            "Not use the Application to store fraudulent or falsified receipts"
          ]
        },
        {
          title: "4. Intellectual Property",
          content: "The Application and its original content, features, and characteristics are the property of ReFound and are protected by international copyright, trademark, and other intellectual property laws. Your receipt data remains your property."
        },
        {
          title: "5. Disclaimer of Warranties",
          content: "The Application is provided \"as is,\" without warranty of any kind. We do not guarantee:",
          items: [
            "The accuracy of enriched product information",
            "The accuracy of warranty or return deadline information",
            "That merchants will accept digital receipt views",
            "Uninterrupted or error-free operation of the Application"
          ],
          additionalContent: "Warranty and return policy information is provided for informational purposes only. Please always verify with the retailer for official policies."
        },
        {
          title: "6. Limitation of Liability",
          content: "To the fullest extent permitted by law, ReFound shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including loss of profits, data, or other intangible losses, resulting from your use of the Application."
        },
        {
          title: "7. Third-Party Services",
          content: "The Application may contain links to third-party websites or services. We are not responsible for the content, privacy policies, or practices of any third-party site or service."
        },
        {
          title: "8. Termination",
          content: "We may terminate or suspend your access to the Application immediately, without notice, for any reason, including violation of these Terms. Upon termination, your right to use the Application will end immediately."
        },
        {
          title: "9. Changes to Terms",
          content: "We reserve the right to modify these Terms at any time. We will notify you of any significant changes through the Application or by email. Your continued use of the Application after modifications constitutes acceptance of the new Terms."
        },
        {
          title: "10. Governing Law",
          content: "These Terms are governed by and construed in accordance with the laws of Canada, without regard to conflict of law provisions."
        },
        {
          title: "11. Contact Us",
          content: "If you have any questions about these Terms, please contact us at",
          email: "info@refoundapp.ca"
        }
      ]
    },
    support: {
      title: "How can we help you?",
      subtitle: "We're here to help you get the most out of ReFound.",
      emailSupport: {
        title: "Email Support",
        description: "Have a question or need help? Send us an email and we'll get back to you within 24 hours.",
        email: "info@refoundapp.ca"
      },
      feedback: {
        title: "Feedback",
        description: "Have ideas for new features or improvements? We'd love to hear from you.",
        buttonText: "Send Feedback"
      },
      faq: {
        title: "Frequently Asked Questions",
        questions: [
          {
            question: "Which retailers are supported?",
            answer: "All of them! You can scan any receipt from any store and use it for a return, with the barcode when the receipt has one. For a list of popular retailers like Canadian Tire, RONA, Home Depot, Walmart, IKEA, Costco, Best Buy, Sports Experts, Decathlon, BMR, Canac, Dollarama and Giant Tiger, items are also enriched with the real product name, a photo, a link and sometimes the warranty when available. We're constantly adding new retailers."
          },
          {
            question: "Is my receipt data secure?",
            answer: "Yes. Your receipts stay private and protected. ReFound never stores your full payment card numbers, and we never sell your personal information."
          },
          {
            question: "Where is my data stored?",
            answer: "Your receipts are kept on your device, with the option to turn on cloud backup so you can find them when you need them. Images backed up to the cloud are kept in private storage and are not publicly accessible. ReFound's main database is hosted in Canada."
          },
          {
            question: "How does receipt scanning work?",
            answer: "When you scan a receipt, we use AI services (OpenAI, Google Gemini, Anthropic) to extract information such as merchant name, items, prices, and dates. We only share the receipt image with these services for processing - no other personal data."
          },
          {
            question: "Can I export or delete my data?",
            answer: "Yes. You can view and export all your data in the app. You can delete individual receipts or your entire account at any time. When you delete data, it is permanently removed from our servers."
          },
          {
            question: "What about warranty reminders?",
            answer: "ReFound tracks warranty expiration dates and return deadlines for your purchases. You can enable notifications to receive reminders before warranties expire. This feature can be turned on or off in your settings."
          }
        ]
      },
      legalDocs: {
        title: "Legal Documents",
        privacyLink: "Privacy Policy",
        termsLink: "Terms of Service"
      }
    },
    demo: {
      title: "No more hunting for receipts",
      subtitle: "Just show the item and ReFound finds its receipt.",
      videoLabel: "ReFound demo video: scan an item to find its receipt",
      videoFallback: "Your browser cannot play this video.",
      download4k: "Download the 4K video",
      downloadCta: "Try ReFound for free",
      freeNote: "Free on iPhone and Android.",
    },
  },
} as const;

export type Language = keyof typeof translations;
export type TranslationKeys = typeof translations.en;
